const isGlassesBundleOrderLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'GLASSES_BUNDLE'
;

export { isGlassesBundleOrderLineItem };
//# sourceMappingURL=line-items.js.map
